<script>
	import {beforeUpdate} from "svelte";
	import {documentos} from "../controladores/store.js";
	import {push} from "svelte-spa-router";
	import Item from "../componentes/itemInicio.svelte";	
	let filtro = "";
	let lista = [];
	
	beforeUpdate(()=>{
		lista = $documentos.filter((el)=>{
			return (el.tipo == "cliente" || el.tipo == "mascota");
		}).filter((el)=>{
			return (el.nombre.toLowerCase().includes(filtro.toLowerCase()) || el.documento.toLowerCase().includes(filtro.toLowerCase()));
		})
		console.log($documentos);
	})
</script>
<div class="flex flex-col items-center justify-start  w-screen max-w-full h-full min-h-screen bg-purple-300">
	<div class="flex w-3/4 items-center justify-center">
		<a href="#/agregar/cliente" class="flex items-center justify-center p-2 bg-purple-500 m-4 text-white rounded"><i class="ri-add-line" /> Cliente </a>
		<a href="#/agregar/mascota" class="flex items-center justify-center p-2 bg-purple-500 m-4 text-white rounded"><i class="ri-add-line"/> Mascota </a>
	</div>
	<input bind:value={filtro} class="p-2 m-4 w-3/4"  type="text" placeholder="Buscar Mascota o Cliente..." />
	<div class="flex flex-col w-3/4">
		{#each lista as item}
			<Item data={item} />
		{/each}
	</div>
</div>

